import {
	SITE_SETTINGS_UPLOAD_START,
	SITE_SETTINGS_UPLOAD_ERROR,
	SITE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateSettingsMutation as mutation } from '../../lib/graphql';

export const updateSiteSettings = ({
	siteName,
	siteTitle,
	metaDescription,
	facebookLink,
	twitterLink,
	instagramLink,
	metaKeyword,
	homeLogo,
	youtubeLink,
	favicon,
	ogImage,
	headerCode,
	bodyCode
}) => {
	return async (dispatch, getState, { client }) => {
		try {

			dispatch({ type: SITE_SETTINGS_UPLOAD_START });

			dispatch(setLoaderStart('SiteSettings'));

			const { data } = await client.mutate({
				mutation,
				variables: {
					siteName,
					siteTitle,
					metaDescription,
					facebookLink,
					twitterLink,
					instagramLink,
					metaKeyword,
					homeLogo,
					youtubeLink,
					favicon,
					ogImage,
					headerCode,
					bodyCode
				}
			})

			if (data?.updateSiteSettings?.status == 200) {
				dispatch({ type: SITE_SETTINGS_UPLOAD_SUCCESS });
				showToaster({ messageId: 'siteSettingsSuccess', toasterType: 'success' });
			}
			else {
				let errorMessage = data?.updateSiteSettings?.errorMessage;
				dispatch({ type: SITE_SETTINGS_UPLOAD_ERROR });
				let requestContent = {
					content: errorMessage
				};
				showToaster({ messageId: 'errorMessage', requestContent, toasterType: 'error' });
			}
			dispatch(setLoaderComplete('SiteSettings'));
		}
		catch (err) {
			dispatch({ type: SITE_SETTINGS_UPLOAD_ERROR });
			let requestContent = {
				content: err
			};
			dispatch(setLoaderComplete('SiteSettings'));
			showToaster({ messageId: 'catchMessage', requestContent, toasterType: 'error' });
		}
	}
}
